import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Item = makeShortcode("Item");
const Group = makeShortcode("Group");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Item title='AchAdditionalInfo' mdxType="Item">
    <Group summary="direct subclasses" open mdxType="Group">
        <Item title="ProvideActivityResultRegistry" mdxType="Item">
            <Group summary='Properties' open mdxType="Group">
                <Item title='provide' subtitle='(ActivityResultRegistry) -> Unit' label='Required' mdxType="Item">
                Provides an ActivityResultRegistry to be used for ACH bank account selection. 
                </Item>
            </Group>
        </Item>
        <Item title="DisplayMandate" mdxType="Item">
            <Group summary='Properties' open mdxType="Group">
                <Item title='onAcceptMandate' subtitle='suspend () -> Unit' label='Required' mdxType="Item">
                Accepts the ACH mandate, completing the payment.
                </Item>
                <Item title='onDeclineMandate' subtitle='suspend () -> Unit' label='Required' mdxType="Item">
                Declines the ACH mandate, cancelling the payment.
                </Item>
            </Group>
        </Item>
    </Group>
    </Item>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      